<!-- Top Banner Section -->
<section class="contact-banner" aria-labelledby="page-title">
  <div class="contact-banner__overlay d-flex flex-column justify-content-center align-items-center">
    <h1 id="page-title" class="ff-satoshi-black m-md-0 mt-5">Long-Term & Monthly Car Rental</h1>
    <p class="ff-satoshi" style="color: #fff; font-size: clamp(18px, 2.5vw, 28px)">
      Top Offers with Q-Autos
    </p>
  </div>
</section>

<!-- Stats Section -->
<section
  class="w-100 d-flex justify-content-center align-items-center mb-4 px-3 px-md-0"
  aria-label="Long-term car rental service statistics"
>
  <div class="stats-section d-flex justify-content-evenly col-12 col-md-11 py-4">
    <div class="d-flex flex-column align-items-center">
      <div class="stat-value">10+</div>
      <div class="stat-label">Years of Experience</div>
    </div>
    <div class="divider"></div>
    <div class="d-flex flex-column align-items-center">
      <div class="stat-value">100+</div>
      <div class="stat-label">Trusted Clients</div>
    </div>
    <div class="divider"></div>
    <div class="d-flex flex-column align-items-center">
      <div class="stat-value">500+</div>
      <div class="stat-label">Bookings</div>
    </div>
  </div>
</section>

<!-- Hero Section -->
<section
  class="chauffeur-hero d-flex flex-wrap justify-content-between p-4 p-md-5 mx-4 mx-md-5"
  aria-label="Long-term and monthly car rental overview"
>
  <div class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-start mb-4 mb-lg-0">
    <img
      src="/images/get-car-rental.png"
      alt="Q-Autos long-term car rental service - flexible monthly car rental options in Qatar"
      class="lets-get"
      loading="lazy"
      decoding="async"
      width="480"
      height="auto"
    />
  </div>
  <div class="hero-info-card col-12 col-lg-7">
    <div class="eyebrow d-flex align-items-center mb-2">
      <span class="rule me-2"></span>
      <span class="label ff-poppins-light">Let’s Get Car Rental</span>
    </div>
    <h2 class="ff-poppins-semibold mb-3 me-3 hero-section-title">Top Offers with Q-Autos</h2>
    <div class="hero-desc-container">
      <p class="hero-desc">
        If you’re planning to drive in Qatar for an extended period, or simply need a reliable
        vehicle for a month or more, Q-Autos has the perfect solution. With our long-term rental
        options you can enjoy excellent value — the longer you rent, the more you save. Our
        streamlined booking process makes it quicker and easier than many conventional leasing
        agreements.
      </p>
      <h3 class="ff-poppins-medium mb-3 me-3 hero-section-subtitle">
        Monthly Car Rental with Q-Autos
      </h3>
      <p id="hero-desc" class="hero-desc">
        Our monthly rental service offers the ideal alternative to buying or leasing a vehicle. Rent
        from just one month, cancel monthly as needed, and enjoy one transparent all-inclusive rate.
      </p>
      <h3 class="ff-poppins-medium mb-3 me-3 hero-section-subtitle">
        For Businesses: Tailored Fleet Solutions
      </h3>
      <p id="hero-desc" class="hero-desc">
        If you're managing mobility for a team, Q-Autos offers corporate rentals with special terms,
        flexible fleets and dedicated support — giving you freedom from the cost and hassle of
        ownership.
      </p>
      <!-- <p id="hero-desc-extra" class="hero-desc" [class.expanded]="showFullText">
        Our monthly rental service offers the ideal alternative to buying or leasing a vehicle. Rent from just one month, cancel monthly as needed, and enjoy one transparent all-inclusive rate.
      </p> -->
    </div>
    <!-- <button type="button" class="btn-pill" aria-label="See more about chauffeur service" [attr.aria-expanded]="showFullText" aria-controls="hero-desc-extra" (click)="toggleText()">
      <span>{{ showFullText ? 'Show less' : 'See more' }}</span>
      <span class="icon-circle" aria-hidden="true">
        <img src="/icons/ic_arrow_upword.svg" alt="" width="14" height="14" [style.transform]="showFullText ? 'rotate(180deg)' : 'rotate(0deg)'" />
      </span>
    </button> -->
  </div>
</section>

<!-- Why Choose Section -->
<section
  class="why-choose d-flex flex-column justify-content-center align-items-start px-4 my-5 mx-4"
  aria-label="Advantages of long-term car rental"
>
  <div class="col-12 col-lg-8 mb-3">
    <div class="eyebrow d-flex align-items-center mb-2">
      <span class="rule me-2"></span>
      <span class="label ff-poppins-light">Comfortable & Dependable</span>
    </div>
    <h2 class="ff-poppins-semibold section-title">
      The Advantages of Long-Term Car Rental vs. Leasing
    </h2>
  </div>
  <div class="features-grid">
    <article class="feature-card feature-img-1" aria-label="Simple and fast booking feature">
      <div class="feature-content">
        <h3 class="feature-title">Simple and fast booking</h3>
        <p class="feature-desc">
          Just select your period, choose your vehicle and you're good to go — no long paperwork
          chain.
        </p>
      </div>
    </article>
    <article class="feature-card feature-img-2" aria-label="No hidden ownership costs feature">
      <div class="feature-content">
        <h3 class="feature-title">No hidden ownership costs</h3>
        <p class="feature-desc">
          No down payment, no depreciation risk, no surprise maintenance bills.
        </p>
      </div>
    </article>
    <article class="feature-card feature-img-3" aria-label="Change your vehicle anytime feature">
      <div class="feature-content">
        <h3 class="feature-title">Change your vehicle anytime</h3>
        <p class="feature-desc">
          If your needs evolve, we'll help you switch to a more suitable car.
        </p>
      </div>
    </article>
    <article class="feature-card feature-img-4" aria-label="Flexible rental periods feature">
      <div class="feature-content">
        <h3 class="feature-title">Flexible rental periods</h3>
        <p class="feature-desc">
          Rent exactly for the time you need – from one month up to 12 months or more.
        </p>
      </div>
    </article>
  </div>
</section>

<!-- Long-Term Rental vs Subscription Section -->
<section class="exclusive-offer mx-4 mx-md-5 my-5" aria-labelledby="exclusive-offer-title">
  <div class="exclusive-offer__inner">
    <div class="exclusive-offer__content">
      <h2 id="exclusive-offer-title" class="title ff-poppins-semibold">
        Long-Term Rental or Subscription: What’s the Difference?
      </h2>

      <p class="subtitle ff-outfit">
        Long-Term Rental: Minimum 28 days, flexible cancellation options, ideal for fixed-term
        needs.
      </p>

      <p class="subtitle ff-outfit">
        Car Subscription: A fixed monthly rate for a term (e.g., 30 days), extra perks like mileage
        packages, and the ability to swap vehicles with minimal notice.
      </p>

      <button
        type="button"
        class="cta ff-satoshi-medium"
        aria-label="Claim your exclusive car rental offer"
        (click)="onContactUs()"
      >
        <span>Contact Us</span>
        <span class="cta__icon" aria-hidden="true">→</span>
      </button>
    </div>

    <div class="exclusive-offer__visual d-flex justify-content-center justify-content-lg-end">
      <div class="visual__stage">
        <img
          class="visual__image"
          src="/images/long-term-rental-or-subscription.png"
          alt="Long-term car rental vs subscription comparison - Q-Autos flexible rental options in Qatar"
          loading="lazy"
          decoding="async"
          width="600"
          height="auto"
        />
      </div>
    </div>
  </div>
</section>
